const EN = {
  // Navbar

  "main-tab": "Home",
  "service-tab": "Services",
  "join-tab": "Join",
  "jobs-tab": "Jobs",
  "visit-tab": "Visit Site",
  "logo-text-1": "Saudi Cleaning",
  "logo-text-2": "Services",
  "our-profile-tab": "Our Profile",
  "arabic-key": "AR",
  "english-key": "EN",
  "about-us-tab": "About Us",
  "define-system": "Define the system",

  // ==========================================================================================================================================

  // Auto Slider

  // ******  labels
  "first-slider-label": "First slide label",
  "second-slider-label": "Second slide label",
  "third-slider-label": "Third slide label",

  // ******  Content
  "first-slider-content":
    "Some representative placeholder content for the first slide.",
  "second-slider-content":
    "Some representative placeholder content for the second slide.",
  "third-slider-content":
    "Some representative placeholder content for the third slide.",

  // ==========================================================================================================================================

  // Services

  // ******  Headers
  "services-header": "Our services and features",
  "first-service-header": "The system works on all platforms",
  "second-service-header": "One integrated system",
  "third-service-header": "Financial management",
  "fourth-service-header": "It provides jobs",

  // ******  Content
  "first-service-content":
    "The system is characterized by providing copies of it that work on different operating platforms such as the web, desktop and mobile, which gives it flexibility and smoothness in use and leaves the freedom of choice to the user. Target the largest possible segment of users.",
  "second-service-content":
    "An integrated, unified system for managing cleaning services throughout the Kingdom of Saudi Arabia, and for organizing customers, delivery workers, and laundries, and automating services between them from one place, easily.",
  "third-service-content":
    "Manage payments and amounts due and required, follow up financial matters and statistics for each of customers, delivery workers and laundries, all from behind the screen. In addition to the possibility of paying and trading money through different platforms.",
  "fourth-service-content":
    "The system helps to easily provide job opportunities without the need for difficult experiences or certificates from the job applicant. For example, it is possible to work within the system as a delivery worker who only needs a delivery vehicle to start work. Providing a comfortable and flexible work environment suitable for people with multiple jobs, and to secure more than one source of income",

  // ******  Buttons
  "first-service-button": "Pay your Bills",
  "second-service-button": "Charge your card",

  // ==========================================================================================================================================

  // Contact Us

  // ******  Headers
  "contactUs-header": "Contact Us",
  "first-contactUs-header": "Contact Information",
  "second-contactUs-header": "Leave Us a message",

  // ******  Communicate Column
  "location-communicate-label": "Address",
  "location-communicate-value": "Kingdom Saudi Arabia - Dammam",
  "phone-communicate-label": "Phone",
  "phone-communicate-value": "+966 0 733 590 55",
  "email-communicate-label": "E-mail Address",
  "email-communicate-value": "mohammad@gmail.com",

  // ******  send message Column
  "name-label": "Name",
  "name-placeholder": "your name",
  "email-send-message-label": "E-mail Address",
  "email-send-message-placeholder": "example@gmail.com",
  "message-contactUs-label": "Message",
  "message-contactUs-placeholder": "what do you want to tell us ?",
  "button-send-message-contactUs": "Send",

  // ==========================================================================================================================================

  // Join Us

  // ******  Headers
  "joinUs-header": "Join Us",

  // ******  Content
  "first-joinUS-content":
    "You can join us and benefit from our services easily and with great savings of time and effort.",

  // ******  Buttons
  "first-joinUs-button": "Let's Start",
  "second-joinUs-button": "Guide Tour",

  // ==========================================================================================================================================

  // Footer
  "copy-right": "all copyrights © Clean app services",
  "download-desktop": "Download Windows App",
  "download-android": "Download Android App",
  "download-iphone": "Download IPhone App",
};

export default EN;
